import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "form-wrapper settings-form" }
const _hoisted_3 = {
  key: 0,
  class: "settings-card"
}
const _hoisted_4 = { class: "settings-card" }
const _hoisted_5 = {
  key: 0,
  class: "ntf-table"
}
const _hoisted_6 = {
  key: 0,
  class: "item-hint ntf-alert-hint"
}
const _hoisted_7 = {
  key: 1,
  class: "chip-editor-item-opts thl-locs ntf-locs"
}
const _hoisted_8 = ["checked", "onChange"]
const _hoisted_9 = ["title"]
const _hoisted_10 = ["onUpdate:modelValue", "disabled"]
const _hoisted_11 = { class: "chip-editor-hint ntf-phone-hint" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "ntf-warn"
}
const _hoisted_14 = { class: "settings-card" }
const _hoisted_15 = { class: "ntf-table" }
const _hoisted_16 = {
  key: 0,
  class: "item-hint ntf-alert-hint"
}
const _hoisted_17 = ["title"]
const _hoisted_18 = ["onUpdate:modelValue", "disabled"]
const _hoisted_19 = { class: "chip-editor-hint ntf-phone-hint" }
const _hoisted_20 = {
  key: 2,
  class: "ntf-warn"
}
const _hoisted_21 = {
  key: 3,
  class: "ntf-warn"
}
const _hoisted_22 = { class: "settings-card" }
const _hoisted_23 = { class: "ntf-table" }
const _hoisted_24 = {
  key: 0,
  class: "item-hint ntf-alert-hint"
}
const _hoisted_25 = ["title"]
const _hoisted_26 = ["onUpdate:modelValue"]
const _hoisted_27 = { class: "chip-editor-hint ntf-phone-hint" }
const _hoisted_28 = {
  key: 3,
  class: "ntf-warn"
}
const _hoisted_29 = {
  key: 4,
  class: "ntf-warn"
}
const _hoisted_30 = {
  key: 5,
  class: "ntf-warn"
}
const _hoisted_31 = {
  key: 0,
  class: "settings-card"
}
const _hoisted_32 = {
  key: 0,
  class: "chip-editor-hint ntf-company-locked"
}
const _hoisted_33 = { class: "item-private ntf-toggle" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "item-private ntf-toggle" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = {
  key: 5,
  class: "btn-row settings-save"
}
const _hoisted_38 = ["disabled"]
const _hoisted_39 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_phone_input = _resolveComponent("phone-input")!
  const _component_email_recipients_editor = _resolveComponent("email-recipients-editor")!
  const _component_settings_layout = _resolveComponent("settings-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "page-bar" }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-bar-sub" }, "Settings"),
        _createElementVNode("div", { class: "page-bar-main" }, "Notifications")
      ])
    ], -1)),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      (_ctx.loaded)
        ? (_openBlock(), _createBlock(_component_settings_layout, {
            key: 0,
            desc: "Choose what's sent and who it goes to."
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                (!_ctx.isAdminAccount && !_ctx.showTeam && !_ctx.showSignOffs && !_ctx.showCompany)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, "There aren't any notifications for you to set up yet."))
                  : _createCommentVNode("", true),
                (_ctx.isAdminAccount)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "settings-section-h" }, "Your Alerts", -1)),
                      _createElementVNode("section", _hoisted_4, [
                        (_ctx.alerts.length)
                          ? (_openBlock(), _createElementBlock("table", _hoisted_5, [
                              _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", null, "Notify me when…"),
                                  _createElementVNode("th", null, "Email"),
                                  _createElementVNode("th", null, "Text")
                                ])
                              ], -1)),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (alert) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: alert.key
                                  }, [
                                    _createElementVNode("td", null, [
                                      _createTextVNode(_toDisplayString(alert.label), 1),
                                      (alert.hint)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(alert.hint), 1))
                                        : _createCommentVNode("", true),
                                      (alert.byLocation && _ctx.isOn(alert) && _ctx.$store.state.user.locations?.length > 1)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.user.locations, (loc) => {
                                              return (_openBlock(), _createElementBlock("label", {
                                                key: loc,
                                                class: "checkbox-input"
                                              }, [
                                                _createElementVNode("input", {
                                                  type: "checkbox",
                                                  checked: _ctx.hasLocation(alert, loc),
                                                  onChange: ($event: any) => (_ctx.toggleLocation(alert, loc))
                                                }, null, 40, _hoisted_8),
                                                _createElementVNode("span", null, _toDisplayString(loc), 1)
                                              ]))
                                            }), 128))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['email', 'text'], (via) => {
                                      return _createElementVNode("td", { key: via }, [
                                        _createElementVNode("label", {
                                          class: _normalizeClass(['item-private', 'ntf-switch', { 'ntf-locked': _ctx.locked(alert, via) }]),
                                          title: _ctx.locked(alert, via) ? 'At least one of email or text stays on for this one' : (via == 'email' ? 'Email' : 'Text') + ': ' + alert.label
                                        }, [
                                          _withDirectives(_createElementVNode("input", {
                                            type: "checkbox",
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.mine.notifications[alert.key][via]) = $event),
                                            disabled: _ctx.locked(alert, via)
                                          }, null, 8, _hoisted_10), [
                                            [_vModelCheckbox, _ctx.mine.notifications[alert.key][via]]
                                          ]),
                                          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "item-private-track" }, [
                                            _createElementVNode("span", { class: "item-private-knob" })
                                          ], -1))
                                        ], 10, _hoisted_9)
                                      ])
                                    }), 64))
                                  ]))
                                }), 128))
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _cache[10] || (_cache[10] = _createElementVNode("h3", null, "Phone for Text Alerts", -1)),
                        _createVNode(_component_phone_input, {
                          modelValue: _ctx.mine.phone,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mine.phone) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_11, [
                          _cache[8] || (_cache[8] = _createTextVNode(" Your text alerts go to this number", -1)),
                          (_ctx.mine.email)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_12, " and email alerts to " + _toDisplayString(_ctx.mine.email), 1))
                            : _createCommentVNode("", true),
                          _cache[9] || (_cache[9] = _createTextVNode(". ", -1)),
                          (_ctx.textsOn && !_ctx.mine.phone)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Add a phone number to get your text alerts."))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.showSignOffs)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _cache[16] || (_cache[16] = _createElementVNode("h2", { class: "settings-section-h" }, "Your Alerts", -1)),
                      _createElementVNode("section", _hoisted_14, [
                        _createElementVNode("table", _hoisted_15, [
                          _cache[13] || (_cache[13] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, "Notify me when…"),
                              _createElementVNode("th", null, "Email"),
                              _createElementVNode("th", null, "Text")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.signOffAlerts, (alert) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: alert.key
                              }, [
                                _createElementVNode("td", null, [
                                  _createTextVNode(_toDisplayString(alert.label), 1),
                                  (alert.hint)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(alert.hint), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['email', 'text'], (via) => {
                                  return _createElementVNode("td", { key: via }, [
                                    _createElementVNode("label", {
                                      class: _normalizeClass(['item-private', 'ntf-switch', { 'ntf-locked': _ctx.signOffLocked(alert, via) }]),
                                      title: _ctx.signOffLockReason(alert, via) || (via == 'email' ? 'Email' : 'Text') + ': ' + alert.label
                                    }, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.signOffs.notifications[alert.key][via]) = $event),
                                        disabled: _ctx.signOffLocked(alert, via)
                                      }, null, 8, _hoisted_18), [
                                        [_vModelCheckbox, _ctx.signOffs.notifications[alert.key][via]]
                                      ]),
                                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "item-private-track" }, [
                                        _createElementVNode("span", { class: "item-private-knob" })
                                      ], -1))
                                    ], 10, _hoisted_17)
                                  ])
                                }), 64))
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _cache[14] || (_cache[14] = _createTextVNode(" Texts go to your phone", -1)),
                          (_ctx.signOffs.phone)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" (" + _toDisplayString(_ctx.formatPhone(_ctx.signOffs.phone)) + ")", 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (_ctx.signOffs.email)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" and emails to " + _toDisplayString(_ctx.signOffs.email) + ", from your employee record", 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          _cache[15] || (_cache[15] = _createTextVNode(". ", -1)),
                          (!_ctx.signOffs.email)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, "There's no email on your employee record, so you can only be texted, and people can't tag you in comments. Ask a Team Hub admin to add one."))
                            : _createCommentVNode("", true),
                          (!_ctx.signOffs.companyOn)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Sign-off reminders aren't turned on for your company yet."))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.showTeam)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _cache[23] || (_cache[23] = _createElementVNode("h2", { class: "settings-section-h" }, "Your Team", -1)),
                      _createElementVNode("section", _hoisted_22, [
                        _createElementVNode("table", _hoisted_23, [
                          _cache[18] || (_cache[18] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, "Notify me when…"),
                              _createElementVNode("th", null, "Email"),
                              _createElementVNode("th", null, "Text")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teamAlerts, (alert) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: alert.key
                              }, [
                                _createElementVNode("td", null, [
                                  _createTextVNode(_toDisplayString(alert.label), 1),
                                  (alert.hint)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(alert.hint), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['email', 'text'], (via) => {
                                  return _createElementVNode("td", { key: via }, [
                                    _createElementVNode("label", {
                                      class: "item-private ntf-switch",
                                      title: (via == 'email' ? 'Email' : 'Text') + ': ' + alert.label
                                    }, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.team.notifications[alert.key][via]) = $event)
                                      }, null, 8, _hoisted_26), [
                                        [_vModelCheckbox, _ctx.team.notifications[alert.key][via]]
                                      ]),
                                      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "item-private-track" }, [
                                        _createElementVNode("span", { class: "item-private-knob" })
                                      ], -1))
                                    ], 8, _hoisted_25)
                                  ])
                                }), 64))
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _cache[19] || (_cache[19] = _createTextVNode(" These go to the email", -1)),
                          (_ctx.team.email)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" (" + _toDisplayString(_ctx.team.email) + ")", 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          _cache[20] || (_cache[20] = _createTextVNode(" and phone", -1)),
                          (_ctx.team.phone)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" (" + _toDisplayString(_ctx.formatPhone(_ctx.team.phone)) + ")", 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          _cache[21] || (_cache[21] = _createTextVNode(" on your employee record", -1)),
                          (_ctx.team.reports)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(", for the " + _toDisplayString(_ctx.team.reports) + " " + _toDisplayString(_ctx.team.reports == 1 ? 'person' : 'people') + " who report to you", 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          _cache[22] || (_cache[22] = _createTextVNode(". ", -1)),
                          (!_ctx.team.reports)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, "No active employees have you as their Reporting To yet, so there's no one to summarize. Set Reporting To on their employee records."))
                            : _createCommentVNode("", true),
                          (_ctx.teamTextsOn && !_ctx.team.phone)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Your employee record has no phone number, so texts can't be sent."))
                            : _createCommentVNode("", true),
                          (!_ctx.team.companyOn)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.isSuperAdmin ? 'Missed powerlist summaries are off for this company. Turn them on under Company Emails & Texts.' : "Missed powerlist summaries aren't turned on for your company yet."), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.showCompany)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _cache[28] || (_cache[28] = _createElementVNode("h2", { class: "settings-section-h" }, "Company Emails & Texts", -1)),
                      (_ctx.canEditRecipients)
                        ? (_openBlock(), _createElementBlock("section", _hoisted_31, [
                            _createVNode(_component_email_recipients_editor, {
                              modelValue: _ctx.formData.EmployeeEmailsNew,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.EmployeeEmailsNew) = $event)),
                              label: "Team Hub Employee Email Recipients",
                              hint: "Notified of employee updates and terminations for the locations ticked, when Send Admin Email is checked on the Edit Employee form. They don't need to be Ironbook users.",
                              "show-locations": true
                            }, null, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isAdmin || _ctx.isSuperAdmin)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (!_ctx.isSuperAdmin)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_32, "These company-wide reminders are managed by your Ironbook contact. Ask them if you'd like either one turned on or off."))
                              : _createCommentVNode("", true),
                            _createElementVNode("section", {
                              class: _normalizeClass(['settings-card', { 'ntf-readonly': !_ctx.isSuperAdmin }])
                            }, [
                              _createElementVNode("label", _hoisted_33, [
                                _cache[24] || (_cache[24] = _createElementVNode("span", { class: "item-private-text" }, [
                                  _createElementVNode("span", { class: "item-private-title" }, "Sign-Off Reminders"),
                                  _createElementVNode("span", { class: "item-hint" }, "Remind standard users once a day when they have new or updated processes to sign. They're texted unless they choose email (sent to their employee record's email) or turn it off. Leave this off while your Ironbook is still being built out, so people aren't reminded about every change.")
                                ], -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.SignReminderTexts) = $event)),
                                  disabled: !_ctx.isSuperAdmin
                                }, null, 8, _hoisted_34), [
                                  [_vModelCheckbox, _ctx.formData.SignReminderTexts]
                                ]),
                                _cache[25] || (_cache[25] = _createElementVNode("span", { class: "item-private-track" }, [
                                  _createElementVNode("span", { class: "item-private-knob" })
                                ], -1))
                              ])
                            ], 2),
                            _createElementVNode("section", {
                              class: _normalizeClass(['settings-card', { 'ntf-readonly': !_ctx.isSuperAdmin }])
                            }, [
                              _createElementVNode("label", _hoisted_35, [
                                _cache[26] || (_cache[26] = _createElementVNode("span", { class: "item-private-text" }, [
                                  _createElementVNode("span", { class: "item-private-title" }, "Missed Powerlist Summaries"),
                                  _createElementVNode("span", { class: "item-hint" }, "Each morning, email managers which of the people who report to them didn't finish yesterday's powerlists. Managers can switch it to text or off for themselves. Set the days each powerlist runs in its editor, so days off aren't counted.")
                                ], -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.MissedPowerlistAlerts) = $event)),
                                  disabled: !_ctx.isSuperAdmin
                                }, null, 8, _hoisted_36), [
                                  [_vModelCheckbox, _ctx.formData.MissedPowerlistAlerts]
                                ]),
                                _cache[27] || (_cache[27] = _createElementVNode("span", { class: "item-private-track" }, [
                                  _createElementVNode("span", { class: "item-private-knob" })
                                ], -1))
                              ])
                            ], 2)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.isAdminAccount || _ctx.showTeam || _ctx.showSignOffs || _ctx.canEditRecipients)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-lg",
                        disabled: _ctx.disableButton,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submit()))
                      }, "Save Changes", 8, _hoisted_38),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn-lg btn-light",
                        disabled: _ctx.disableButton,
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.load()))
                      }, "Cancel", 8, _hoisted_39)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}